import { $, merge } from "glamor";
import { theme } from "styles/theme";

export const addTargetValuesStyles = () =>
    merge(
        $(".container", {
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
        }),
        $(" .tabWrapper", {
            width: "400px !important",
        }),
        $(" .tab", {
            backgroundColor: "white !important",
            color: `${theme.palette.darkGrey} !important`,
            padding: "0 30px !important",
            textTransform: "none !important",
        }),
        $(" .tabPanel", {
            height: "100%",
        })
    );
